module.exports = __webpack_public_path__ + "media/images/1024-d28db58da04f6c21bb633ee8d0c766a4.png";